import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./utils/ScrollToTop";
import Layout from "./layout/Layout";

// Pages
import Signin        from "./pages/Signin";
import Dashboard     from "./pages/dashboard/Dashboard";
import FPOProfile    from "./pages/profile/FPOProfile";
import FPOStaff      from "./pages/staff/FPOStaff";
import FPOCommodity  from "./pages/commodities/FPOCommodity";
import FPOMembers    from "./pages/members/FPOMembers";
import FPOBroadcasts from "./pages/notifications/FPOBroadcasts";
import FPOTemplates  from "./pages/notifications/FPOTemplates";
import NewBroadcast  from "./pages/notifications/NewBroadcast";
import BroadcastDetail from "./pages/notifications/BroadcastDetail";
import PageNotFound  from "./pages/PageNotFound";
import Procurement   from "./pages/procurement/Procurement";
import AssetRegister from "./pages/assets/AssetRegister";

// Auth guard helper
import { isLoggedIn } from "./helpers/local_storage_helpers";

// ── Protected Route ────────────────────────────────────────────────
const ProtectedRoute = ({ children }) => {
  if (!isLoggedIn()) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="w-full">
        <Routes>
          {/* ── Public ── */}
          <Route
            path="/"
            element={
              <Layout noSidebar>
                <Signin />
              </Layout>
            }
          />

          {/* ── Protected ── */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Layout>
                  <FPOProfile />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/staff"
            element={
              <ProtectedRoute>
                <Layout>
                  <FPOStaff />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/commodities"
            element={
              <ProtectedRoute>
                <Layout>
                  <FPOCommodity />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/members"
            element={
              <ProtectedRoute>
                <Layout>
                  <FPOMembers />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <Layout>
                  <FPOBroadcasts />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications/templates"
            element={
              <ProtectedRoute>
                <Layout>
                  <FPOTemplates />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <NewBroadcast />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <BroadcastDetail />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/procurement"
            element={
              <ProtectedRoute>
                <Layout>
                  <Procurement />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/assets"
            element={
              <ProtectedRoute>
                <Layout>
                  <AssetRegister />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* ── 404 ── */}
          <Route
            path="*"
            element={
              <ProtectedRoute>
                <Layout>
                  <PageNotFound />
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
